<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {LoanRequestOption, VisitPickupability} from 'src/typings';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';
    import KpPluralizeText from 'shared/components/kp-pluralize-text/KpPluralizeText.svelte';
    import BuildingsList from './shared/BuildingsList.svelte';
    import LoanOptionPanelBody from './shared/LoanOptionPanelBody.svelte';

    export let option: LoanRequestOption<VisitPickupability>;

    const localize = getLocalization();
</script>

<KpGenericPanel>
    <svelte:fragment slot="heading">
        <strong>{localize(/* @kp-localization loan.Prezencne */ 'loan.Prezencne')}</strong>
        <KpChipTag chipSize="sm" chipStyle="warning">{localize(/* @kp-localization loan.Prezencni */ 'loan.Prezencni')}</KpChipTag>
    </svelte:fragment>

    <LoanOptionPanelBody>
        <div>
            {#if option.requestItems.length === 1}
                <KpPluralizeText count={option.capability.buildings.length}
                                 oneCountText={localize(/* @kp-localization loan.DokumentJePrezencneNaBudove */ 'loan.DokumentJePrezencneNaBudove')}
                                 moreText={localize(/* @kp-localization loan.DokumentJePrezencneNaBudovach */ 'loan.DokumentJePrezencneNaBudovach')}/>
            {:else if option.requestItems.length > 1}
                <KpPluralizeText count={option.capability.buildings.length}
                                 oneCountText={localize(/* @kp-localization loan.DokumentyJsouPrezencneNaBudove */ 'loan.DokumentyJsouPrezencneNaBudove')}
                                 moreText={localize(/* @kp-localization loan.DokumentyJsouPrezencneNaBudovach */ 'loan.DokumentyJsouPrezencneNaBudovach')}/>
            {/if}
        </div>

        <BuildingsList {option}/>
    </LoanOptionPanelBody>
</KpGenericPanel>